export const MenuItems = [
    {
        title : "Inicio",
        url : "/",
        cName : "nav-links",
        
    },
    {
        title : "Nosotros",
        url : "/about",
        cName : "nav-links",
        
    }, 
    {
        title : "Servicios",
        url : "/services",
        cName : "nav-links",
    
    },
]